import {
  AddresseeText,
  AddresseeWrapper,
  BodyText,
  DateLine,
  EmailViewerWrapper,
  SubjectWrapper,
} from "./EmailViewer.styles"

export interface Props {
  dateLine: string
  from: string
  to: string
  cc: string
  subject: string
  body: string
}

export default function EmailViewer(props: Props) {
  return (
    <EmailViewerWrapper>
      <DateLine>{props.dateLine}</DateLine>
      <AddresseeWrapper>
        <AddresseeText>From: {props.from}</AddresseeText>
        <AddresseeText>To: {props.to}</AddresseeText>
        <AddresseeText>CC: {props.cc}</AddresseeText>
      </AddresseeWrapper>
      <SubjectWrapper>
        <AddresseeText>Subject: {props.subject}</AddresseeText>
      </SubjectWrapper>
      <BodyText display={"block"}>{props.body}</BodyText>
    </EmailViewerWrapper>
  )
}
